<template>
  <div class="file-upload-details">
    <section class="section">
      <b-loading :active="isLoading"></b-loading>
      <div class="container">
        <div class="columns">
          <div class="column is-full">
            <div class="box">
              <div class="columns" style="margin-top: 16px">
                <div class="column">
                  <header class="heading">
                    <p class="modal-card-title">{{ pageTitle }}</p>
                  </header>
                </div>
              </div>
              <div class="columns" style="margin-top: 16px; margin-left: 0">
                <div class="column is-full">
                  <b-field class="file" :class="{'has-name': !!selectedFile}">
                    <b-upload v-model="selectedFile" class="file-label"
                              accept=".xls, .xlsx"
                              @input="onFileSelected">
                      <span class="file-cta">
                        <b-icon class="file-icon" icon="upload"></b-icon>
                        <span class="file-label">{{ $t('import-file-details-view.select-file-button') }}</span>
                      </span>
                      <span class="file-name" v-if="selectedFile">
                        {{ selectedFile.name }}
                      </span>
                    </b-upload>
                    <b-button v-if="isFileSelected" class="button is-primary is-danger" icon-left="delete"
                              @click="onFileRemoveSelected"></b-button>
                  </b-field>
                </div>
              </div>
              <div v-if="!selectedFile" class="column">
                <span class="is-size-6">{{ $t('import-file-details-view.file-allowed-size') }}</span><br/>
                <span class="is-size-6">{{ $t('import-file-details-view.file-allowed-rows') }}</span><br/>
                <span class="is-size-6">{{ $t('import-file-details-view.file-allowed-type') }}</span><br/><br/>
                <span class="is-size-6">{{ $t('import-file-details-view.import-condition') }}</span>
              </div>
              <div class="columns is-mobile" style="margin-top: 16px">
                <div class="column is-narrow">
                  <b-button class="button" @click="cancelClicked" icon-left="close-thick" tabindex="31">
                    {{ $t('common.cancel') }}
                  </b-button>
                </div>
                <div class="column is-narrow">
                  <b-button v-if="currentUserAccess('ProjectFilesDetails', this.UserActions.UPDATE, this.project_id)"
                            class="button is-primary" @click="uploadClicked" icon-left="import" tabindex="32">
                    {{ $t('import-file-details-view.upload-button') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "ImportFromFileDetails",
  props: {
    'project_id': {
      type: String
    }
  },
  data() {
    return {
      selectedFile: null,
      isLoading: false
    }
  },
  methods: {
    onFileSelected() {
    },
    onFileRemoveSelected() {
      this.selectedFile = null
    },
    uploadFile: function () {
      if (this.selectedFile !== null && this.selectedFile !== undefined) {
        this.isLoading = true;
        let userEmail = firebase.auth().currentUser.email
        let metadata = {
          customMetadata: {
            'email': userEmail
          }
        };
        const filePath = this.getFilePath();
        this.getFileRefInDatabase(filePath).put(this.selectedFile, metadata).then(() => {
          this.isLoading = false;
          this.$emit('fileUploaded', filePath);
        }).catch((error) => {
          this.isLoading = false;
          let message = this.getFirebaseStorageError(error.code);
          this.showError(message);
          console.log('Import file error: ', error?.code);
        });
      } else {
        console.log("No import file is selected!")
      }
    },
    getFileRefInDatabase: function (filePath) {
      const filePathInDatabase = this.getStorageRootFolder() + '/' + filePath
      return firebase.storage().ref(filePathInDatabase)
    },
    getFilePath: function () {
      const filePath = 'projects/' + this.project_id + '/imports/' + this.selectedFile.name
      return filePath
    },
    /*
     UI Events
     */
    cancelClicked: function () {
      this.$emit('close');
    },
    uploadClicked: function () {
      this.uploadFile()
    }
  },
  computed: {
    isFileSelected() {
      return this.selectedFile !== null && this.selectedFile !== undefined && this.selectedFile !== "";
    },
    pageTitle() {
      return this.$t('import-file-details-view.title')
    }
  }
};
</script>
